import * as yup from 'yup';
import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
export interface IPasswordSettingMeta {
  minLength: FormInputMeta;
  maxLength: FormInputMeta;
  attemptLimit: FormInputMeta;
  sessionsNumber: FormInputMeta;
  nbOfDayBeforeExpiration: FormInputMeta;
  nbOfDayExpirationAlert: FormInputMeta;
  changeAfterFirstLogin: FormInputMeta;
  changeOnFirstLogin: FormInputMeta,

  // Schema
  schema: any;
}

const PasswordSettingsMeta: IPasswordSettingMeta = {} as IPasswordSettingMeta;

PasswordSettingsMeta.minLength = {
  name: 'minLength',
  type: 'number',
  // placeholder: 'Longeur Minimale',
  validation: yup.string().required(),
};

PasswordSettingsMeta.maxLength = {
  name: 'maxLength',
  type: 'number',
  // placeholder: 'Longeur Maximale',
  validation: yup.string().required(),
};
PasswordSettingsMeta.attemptLimit = {
  name: 'attemptLimit',
  type: 'number',
  // placeholder: 'Limite de tentative',
  validation: yup.string().required(),
};

PasswordSettingsMeta.sessionsNumber = {
  name: 'sessionsNumber',
  type: 'number',
  // placeholder: 'Nombre de sessions',
  validation: yup.string().required(),
};

PasswordSettingsMeta.nbOfDayBeforeExpiration = {
  name: 'nbOfDayBeforeExpiration',
  type: 'number',
  // placeholder: 'Entrer un nombre',
  validation: yup.string().required(),
};

PasswordSettingsMeta.nbOfDayExpirationAlert = {
  name: 'nbOfDayExpirationAlert',
  type: 'number',
  // placeholder: 'Entrer un nombre',
  validation: yup.string().required(),
};

PasswordSettingsMeta.changeOnFirstLogin = {
  label: 'Changer le mot de passe au premier login?',
  name: 'changeOnFirstLogin',
  type: 'checkbox',
  // placeholder: 'Entrer un nombre',
  checked: true,
  validation: yup.string().required(),
};

const validationSchema = getValidationSchema(PasswordSettingsMeta);
PasswordSettingsMeta.schema = yup.object().shape(validationSchema);

export default PasswordSettingsMeta;
